import { BfxBlotterOrdersContextMenuItemCancelState } from "./BfxBlotterOrdersContextMenuItemCancelState";

import { BfxBlotterOrdersContextMenuState } from "./BfxBlotterOrdersContextMenuState";
import { BfxBlotterOrdersContextMenuItem } from "./BfxBlotterOrdersContextMenuItem";

import { BfxBlotterAction } from "../bfx-base-blotter/BfxBlotterAction";

import { ContextMenuItemState } from "../ContextMenuItemState";
import { ContextMenuItemStateCommand } from "../ContextMenuItemStateCommand";
import { ContextMenuItemStateCommandCriteria } from "../ContextMenuItemStateCommandCriteria";
import { ContextMenuState } from "../ContextMenuState";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BfxBlotterOrdersContextMenuItemTakeState } from "./BfxBlotterOrdersContextMenuItemTakeState";

export class BfxBlotterOrdersContextMenuTakeItem extends BfxBlotterOrdersContextMenuItem {
  constructor() {
    super(
      BfxBlotterAction.ACTION_TAKE,
      "Take",
      BfxBlotterOrdersContextMenuTakeItem.checkAvailableFn(),
      BfxBlotterOrdersContextMenuTakeItem.checkEnabledFn(),
      ContextMenuItemStateCommandCriteria.MenuItem,
      ContextMenuItemStateCommandCriteria.Item,
    );
  }

  public reset(): void {
    let oldState = this.state;
    this.state = new BfxBlotterOrdersContextMenuItemTakeState();
    this.state.title = oldState.title;
  }

  private static checkAvailableFn(): ContextMenuItemStateCommand<CubiqTS.OrderDataImpl> {
    return function (
      this: void,
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: ContextMenuItemState,
    ) {
      itemState.available = menuState.canStealFromAuto || menuState.canStealFromManual;
    };
  }

  private static checkEnabledFn(): ContextMenuItemStateCommand<CubiqTS.OrderDataImpl> {
    return function (
      this: void,
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: BfxBlotterOrdersContextMenuItemTakeState,
      item: CubiqTS.OrderDataImpl,
    ) {
      if (!item) {
        itemState.enabled = false;
      } else if (!itemState.enabled || itemState.count == 0) {
        itemState.enabled =
          itemState.enabled && BfxBlotterOrdersContextMenuTakeItem.checkOrderState(item, menuState);
        itemState.enabled =
          itemState.enabled &&
          BfxBlotterOrdersContextMenuTakeItem.checkMembership(item, menuState, itemState);
        itemState.enabled =
          itemState.enabled && BfxBlotterOrdersContextMenuTakeItem.checkLockType(item);
      }

      itemState.count++;
    };
  }

  private static checkMembership(
    item: CubiqTS.OrderDataImpl,
    menuState: BfxBlotterOrdersContextMenuState,
    itemState: BfxBlotterOrdersContextMenuItemTakeState,
  ): boolean {
    let isATrader: boolean = CubiqTS.UserType.TRADER == menuState.activeUser.userTypeId;

    let tg: CubiqTS.TradingGroupImpl = menuState.traderGroups.get(item.deskId.toString());
    let isAMember: boolean = tg != null;

    let enabled: boolean = false;
    if (isATrader && isAMember) {
      enabled =
        (tg.isAutoFilledFg && menuState.canStealFromAuto) ||
        (!tg.isAutoFilledFg && menuState.canStealFromManual);
    }

    return enabled;
  }

  private static checkOrderState(
    item: CubiqTS.OrderDataImpl,
    menuState: BfxBlotterOrdersContextMenuState,
  ): boolean {
    let enabled: boolean = false;

    switch (item.orderState) {
      case CubiqTS.OrderState.ACTIVE:
      case CubiqTS.OrderState.PENDING: // orders that are activation pending (strategy legs covered by this state also but should have no affect on menu)
      case CubiqTS.OrderState.SUSPENDED:
      case CubiqTS.OrderState.TRIGGERED:
      case CubiqTS.OrderState.PENDING_CANCELLATION:
      case CubiqTS.OrderState.FILLING:
      case CubiqTS.OrderState.FILL_PENDING:
        enabled = true;
        break;
      default:
        enabled = false;
        break;
    }

    let alreadyInTransfer: boolean = item.targetDeskId != null;
    return enabled && !alreadyInTransfer;
  }

  private static checkLockType(item: CubiqTS.OrderDataImpl): boolean {
    let enabled: boolean = true;

    if (
      item.lockType !== undefined &&
      item.lockType !== null &&
      (item.lockType === CubiqTS.LockType.FILL_LOCK ||
        item.lockType === CubiqTS.LockType.FILL_NOW_LOCK)
    ) {
      enabled = false;
    }

    return enabled;
  }

  public static get state(): any {
    return new BfxBlotterOrdersContextMenuItemTakeState();
  }
}
